export default __webpack_public_path__ + "static/media/sarah.8715b127.jpg";